/**
 * Mock 模块：heart_voyage_daily_info
 * 默认进行中对齐 DailyEventPanel state-in-progress（3 轮 / 5 行 / 2+2 奖励）。
 * round_countdown 保持 7200，避免 VoyageContent 海面切暴风雨。
 * @see mockMd/heart_voyage_daily_info.md
 */
import storiesAvatar from '../components/DailyEventPanel/stories-images/stories-avatar.png'
import storiesReward from '../components/DailyEventPanel/stories-images/stories-reward.png'
import {
  RelationType,
  type HeartVoyageDailyInfoData,
  type TaskReward,
} from '../types'

const MOCK_USER_AVATAR = storiesAvatar
const MOCK_REWARD_ICON = storiesReward
export const MOCK_REWARD_DESC_NAME = 'Event Wall of Honor*2day'

/** 静图海面：>3600 秒（VoyageContent 共用本 Mock） */
export const MOCK_ROUND_COUNTDOWN_STATIC = 3700

const mockReward = (id: number): TaskReward => ({
  id,
  icon: MOCK_REWARD_ICON,
  desc: MOCK_REWARD_DESC_NAME,
  privilege_id: id,
  has_show_effect: true,
  quantity: 2,
  reward_type: 1,
})

const mockPassRewards: TaskReward[] = [mockReward(9101), mockReward(9102)]
const mockTop1Rewards: TaskReward[] = [mockReward(9111), mockReward(9112)]

const mockMember = (
  index: number,
  opts: {
    affinity: number
    is_self: boolean
    ship_level: number
    ship_form: number
    rel_type: RelationType
    nameA: string
    nameB: string
  }
) => {
  const idA = 10001 + index * 2
  const idB = 10002 + index * 2
  return {
    pair_key: `${idA}:${idB}`,
    affinity: opts.affinity,
    is_self: opts.is_self,
    ship_level: opts.ship_level,
    ship_form: opts.ship_form,
    rel_type: opts.rel_type,
    member_a: {
      id: idA,
      name: opts.nameA,
      zy_id: String(idA),
      avatar: MOCK_USER_AVATAR,
      gender: 2,
    },
    member_b: {
      id: idB,
      name: opts.nameB,
      zy_id: String(idB),
      avatar: MOCK_USER_AVATAR,
      gender: 1,
    },
  }
}

const inProgressRounds = [
  {
    round: 1,
    event_time: '08:00',
    end_time: '16:00',
    pass_rewards: mockPassRewards,
    top1_rewards: mockTop1Rewards,
    round_status: 1,
  },
  {
    round: 2,
    event_time: '16:00',
    end_time: '24:00',
    pass_rewards: mockPassRewards,
    top1_rewards: mockTop1Rewards,
    round_status: 1,
  },
  {
    round: 3,
    event_time: '24:00',
    end_time: '08:00',
    pass_rewards: mockPassRewards,
    top1_rewards: mockTop1Rewards,
    round_status: 0,
  },
]

/** @see mockMd/heart_voyage_daily_info.md · 默认 = 进行中本组 */
export const HeartVoyageDailyInfoMock: HeartVoyageDailyInfoData = {
  err_msg: '',
  date: '20260812',
  round: 2,
  group_id: 1,
  pair_affinity: 82600,
  threshold: 100000,
  members: [
    mockMember(5, {
      affinity: 9800,
      is_self: false,
      ship_level: 12,
      ship_form: 3,
      rel_type: RelationType.Couple,
      nameA: 'Cance Aweel',
      nameB: 'Cance Aweel',
    }),
    mockMember(1, {
      affinity: 8600,
      is_self: false,
      ship_level: 8,
      ship_form: 2,
      rel_type: RelationType.Confidant,
      nameA: 'Carol',
      nameB: 'Dave',
    }),
    mockMember(0, {
      affinity: 82600,
      is_self: true,
      ship_level: 12,
      ship_form: 2,
      rel_type: RelationType.Couple,
      nameA: 'Alice',
      nameB: 'Bob',
    }),
    mockMember(3, {
      affinity: 4200,
      is_self: false,
      ship_level: 4,
      ship_form: 1,
      rel_type: RelationType.Brother,
      nameA: 'Eve',
      nameB: 'Frank',
    }),
    mockMember(4, {
      affinity: 900,
      is_self: false,
      ship_level: 1,
      ship_form: 1,
      rel_type: RelationType.Sister,
      nameA: 'Gina',
      nameB: 'Hank',
    }),
  ],
  round_status: 1,
  can_join: true,
  eliminated: false,
  pre_eliminate_index: 4,
  rounds: inProgressRounds,
  round_countdown: MOCK_ROUND_COUNTDOWN_STATIC,
}

/** 未参赛：仍出轮次 + 倒计时 + 三级 Tab */
export const HeartVoyageDailyInfoNoJoinMock: HeartVoyageDailyInfoData = {
  ...HeartVoyageDailyInfoMock,
  can_join: false,
  eliminated: false,
  pair_affinity: 0,
  members: [],
  pre_eliminate_index: 0,
}

/** 挑战失败：不出进度 / 组榜 / 奖励 */
export const HeartVoyageDailyInfoFailMock: HeartVoyageDailyInfoData = {
  ...HeartVoyageDailyInfoMock,
  can_join: true,
  eliminated: true,
  members: [],
  pre_eliminate_index: 0,
}

/** VRT `pair_key` 覆盖；真实请求走 reducers thunk */
export function resolveDailyInfoMock(
  pair_key?: string
): HeartVoyageDailyInfoData {
  if (pair_key === 'dc-daily-nojoin') {
    return HeartVoyageDailyInfoNoJoinMock
  }
  if (pair_key === 'dc-daily-fail') {
    return HeartVoyageDailyInfoFailMock
  }
  return HeartVoyageDailyInfoMock
}

export const DailyInfoGuideMock = {
  err_msg: '',
  date: '20260819',
  round: 1,
  group_id: 8,
  pair_affinity: 0,
  threshold: 0,
  members: [],
  round_status: 0,
  can_join: true,
  eliminated: false,
  pre_eliminate_index: 0,
  rounds: [
    {
      round: 1,
      event_time: '00:00',
      end_time: '08:00',
      pass_rewards: [
        {
          id: 171185,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
      top1_rewards: [
        {
          id: 171188,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
      round_status: 1,
    },
    {
      round: 2,
      event_time: '08:00',
      end_time: '19:00',
      pass_rewards: [
        {
          id: 171186,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
      top1_rewards: [
        {
          id: 171189,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
      round_status: 0,
    },
    {
      round: 3,
      event_time: '19:00',
      end_time: '24:00',
      pass_rewards: [
        {
          id: 171187,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
      top1_rewards: [
        {
          id: 171190,
          icon: 'https://img01.mehiya.com/imgv2/png/id/173698800235',
          desc: '‪Coins*100',
          privilege_id: null,
          car_effect: null,
          has_show_effect: false,
          quantity: 100,
          reward_type: 4,
        },
      ],
      round_status: 0,
    },
  ],
  round_countdown: 4523,
} as unknown as HeartVoyageDailyInfoData as HeartVoyageDailyInfoData
